// @flow
import * as factories from './factories';
import * as validation from './validation';
import * as transformsV1 from './transforms.v1';
import * as apiV1 from './api.v1';

// V2 shares only the UI factories + form validation; its data layer (routes,
// transforms, response handling) lives in the api-client-backed React Query
// hooks under queries/ rather than a hand-rolled model surface.
export const SessionDocument = {
  ...factories,
  ...validation,
};

// Legacy V1 surface, used behind the documentation_v2 flag for rollout.
// Shares the factories/validation with V2; overrides the transforms + api with
// the V1 (snake_case, org-in-path REST) implementations. Remove with the flag.
export const SessionDocumentV1 = {
  ...factories,
  ...validation,
  ...transformsV1,
  ...apiV1,
};
